import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function VehicleForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    car_number: '',
    manufacturer: '',
    model: '',
    leased_from: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/vehicles', formData);
      toast.success('Vehicle created successfully');
      navigate('/vehicles');
    } catch (error) {
      console.error('Submit failed:', error);
      toast.error('Failed to create vehicle');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="vehicle-form-page">
      <div className="mb-6">
        <Button
          onClick={() => navigate('/vehicles')}
          variant="ghost"
          data-testid="back-button"
          className="mb-4"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Vehicles
        </Button>
        <h1 className="text-4xl font-black font-heading text-gray-900 mb-2">Add New Vehicle</h1>
        <p className="text-gray-600">Enter vehicle details below</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="car_number">Car Number *</Label>
              <Input
                id="car_number"
                name="car_number"
                data-testid="input-car-number"
                value={formData.car_number}
                onChange={handleChange}
                required
                placeholder="e.g., KA01AB1234"
              />
            </div>
            <div>
              <Label htmlFor="manufacturer">Manufacturer *</Label>
              <Input
                id="manufacturer"
                name="manufacturer"
                data-testid="input-manufacturer"
                value={formData.manufacturer}
                onChange={handleChange}
                required
                placeholder="e.g., Toyota"
              />
            </div>
            <div>
              <Label htmlFor="model">Model *</Label>
              <Input
                id="model"
                name="model"
                data-testid="input-model"
                value={formData.model}
                onChange={handleChange}
                required
                placeholder="e.g., Innova"
              />
            </div>
            <div>
              <Label htmlFor="leased_from">Leased From *</Label>
              <Input
                id="leased_from"
                name="leased_from"
                data-testid="input-leased-from"
                value={formData.leased_from}
                onChange={handleChange}
                required
                placeholder="e.g., ABC Leasing"
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate('/vehicles')}
              data-testid="cancel-button"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="submit-vehicle-button"
              disabled={loading}
              className="bg-shizah-blue hover:bg-blue-700 text-white"
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin mr-2" size={20} />
                  Creating...
                </>
              ) : (
                'Create Vehicle'
              )}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}